export default __webpack_public_path__ + "static/silk-b7332bf3b042a7f5ea0843867b4213b2.jpg";